import { render } from "./pickUpInfo.vue?vue&type=template&id=5b7aa844"
import script from "./pickUpInfo.vue?vue&type=script&lang=js"
export * from "./pickUpInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__